import React, { useState } from "react";
import { useForm, FormContextInterface } from "./context";
import {
  SchoolName,
  StudentDetails,
  Parent,
  Submitted,
  Address,
} from "./components";
import { Box } from "@mui/material";
import ScrollableElements from "./components/scroll-element";

const SignupForm = () => {
  const { activeStep, formSubmitted } = useForm() as FormContextInterface;
  const [move, setMove] = useState(false);

  const handleClick = () => {
    setMove(!move);
  };
  return (
    <Box className="form-wrapper">
      {formSubmitted ? (
        <Submitted />
      ) : (
        <>
          <ScrollableElements />
          <Box className={`form-section active `}>
            <SchoolName />
          </Box>
          <Box
            className={`form-section ${
              activeStep.studentDetails ? "active" : "inactive"
            }`}
          >
            <StudentDetails />
          </Box>
          <Box
            className={`form-section ${
              activeStep.parentDetails ? "active" : "inactive"
            }`}
          >
            <Parent handleClick={handleClick} />
          </Box>
          <Box
            className={`form-section ${
              activeStep.addressDetails ? "active" : "inactive"
            }`}
          >
            <Address move={move} />
          </Box>
        </>
      )}
      <input name="school-fees" id="school-fees" type="hidden" value="" />
      <input
        name="NoticePeriodRequired"
        id="NoticePeriodRequired"
        type="hidden"
        value=""
      />
      <input type="hidden" id="feeprep" value="" />
      <input type="hidden" id="feeprep_normal" value="" />
      <input type="hidden" id="feeprep_newprep" value="" />
      <input type="hidden" id="feeprim" value="" />
    </Box>
  );
};

export { SignupForm };
